import React from "react";
import "./LoadingOverlay.css";

export default function LoadingOverlay({ greyout }) {
  return (
    <div className={`LoadingOverlay ${greyout ? "LoadingOverlay--greyout" : ""}`} />
  );
}
